export const SHOW_USER_MODAL = 'show_user_modal';
export const HIDE_USER_MODAL = 'hide_user_modal';
export const CHANGE_ROLE = 'change_role';
export const GET_SANITARY_BOOK = 'get_sanitary_book';
export const UPDATE_SANITARY_BOOK = 'update_sanitary_book';